import React from "react";
import { isData, splitDate } from "@/utility/helperFunctions";

const NomineeDetails = ({ data, id }) => {
  return (
    <div className="tw-mt-4 tw-mb-3">
      <div className="tw-text-[14px] tw-mb-2">Nominee {id + 1}</div>
      <div className="tw-grid tw-grid-cols-4 tw-gap-4">
        <div className="tw-col-span-2">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Nominee Name
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-inline-flex tw-items-center tw-gap-[6px] tw-capitalize">
            {isData(data?.nomineeName)}
          </div>
        </div>
        <div className="tw-col-span-2">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Relation
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-capitalize">
            {isData(data?.nomineeRelation)}
          </div>
        </div>
        <div className="tw-col-span-2">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Nominee DOB
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed tw-inline-flex tw-items-center tw-gap-[6px]">
            {splitDate(data?.nomineeDob," ")?.date}
          </div>
        </div>
        <div className="tw-col-span-2">
          <div className="tw-text-[12px] tw-text-customGray67 tw-font-nmmed">
            Share Allocation
          </div>
          <div className="tw-text-[14px] tw-text-primaryBlack tw-font-nmmed">
            {isData(data?.nomineeAlocation)}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default NomineeDetails;
